import { useState, useEffect } from 'react';
import styled from 'styled-components';
import useStore from '@/store/useStore';
import beTwMerge from '@/utils/beTwMerge';
import Button from '@/components/homepage/Button';
import { trackEventWithObject } from '@/utils/gaDataPush';
import FontIcon from '../FontIcon';

const Container = styled.div`
  position: relative;
  .dropdown-locations {
    .radio-green-cricle {
      padding: 5px 0;
      padding-left: 22px;
      display: block;
      position: relative;
      text-decoration: none;
      cursor: pointer;

      i.icons-checked:after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 10px;
        height: 10px;
        background-color: #183e40;
        border-radius: 100%;
      }
      i {
        background: 0;
        width: 16px;
        height: 16px;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 100%;
        position: absolute;
        left: 0;
        margin-top: 1px;
        .icons-checked:after {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 10px;
          background-color: #808080;
          border-radius: 100%;
        }
      }
    }
    .btn-default4 {
      color: #333;
      border-color: #333;
      background: transparent;
      &:hover {
        color: white;
        background-color: #2c2c2c;
        border-color: #2c2c2c;
      }
    }
  }
`;

interface IVirtualAppointment {
  loading: boolean;
  setLoading: (loadgin: boolean) => void;
}

export default function VirtualAppointment({ loading, setLoading }: IVirtualAppointment) {
  const { store, headerDropdown, showroomName, visitText } = useStore(state => state.showroom);
  const updateShowroom = useStore(state => state.updateShowroom);

  const [isOpen, setIsOpen] = useState(false);
  const [storeData, setStoreData] = useState({
    label: 'Virtual Appointment',
    dataLabel: 'Virtual Appointment',
    icon: 'tv',
    link: '/stores/virtual-appointment/',
  });

  function onMouseHover() {
    if (store?.location_name !== 'Other') {
      setIsOpen(true);
    }
  }

  useEffect(() => {
    if (headerDropdown?.length! >= 0) {
      const storeLabel = store?.location_name === 'Other' ? 'Virtual Appointment' : `${showroomName}`;
      const storeIcon = store?.location_name === 'Other' ? 'tv' : 'location';
      const storeLink = store?.location_page || '/stores/virtual-appointment/';
      setStoreData({ label: storeLabel, dataLabel: visitText!, icon: storeIcon, link: storeLink });
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerDropdown?.length, showroomName, store, visitText]);

  const { label, icon, link } = storeData;
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!loading ? (
        <Container onMouseEnter={onMouseHover} onMouseLeave={() => setIsOpen(false)}>
          <a
            href={link}
            className="navitem hover:tw-text-be-turquoise-green"
            onClick={() => {
              const isVirtual = store?.location_name === 'Other';
              trackEventWithObject({
                event: 'header',
                general_event_category: isVirtual ? 'Virtual Appointment' : 'Visit Showrooms',
                general_event_section: 'Main Icon',
                general_event_details: isVirtual ? 'Undefined' : showroomName || 'Undefined',
              });
            }}
          >
            <div className={beTwMerge(isOpen && 'tw-text-be-turquoise-green', 'tw-flex tw-items-center')}>
              <FontIcon name={icon} />
              <span className="tw-pl-[4px] visit">
                {label}
                {store?.location_name !== 'Other' && (
                  <svg
                    data-accordion-icon
                    className={beTwMerge(
                      'tw-w-[12px] tw-h-[6px] tw-shrink-0 !tw-text-[#333] hover:!tw-text-[#333] tw-ml-[3px] tw-align-middle',
                      !isOpen && 'tw-rotate-[-180deg]'
                    )}
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                      d="M9 5 5 1 1 5"
                    />
                  </svg>
                )}
              </span>
            </div>
          </a>
          {!!headerDropdown?.length && isOpen && (
            <div
              className="dropdown-locations tw-bg-white tw-hidden bs-tablet:tw-block tw-absolute tw-w-[340px] tw-left-[-18px] tw-p-5
                    tw-border tw-shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] tw-border-solid tw-border-[#d9d9d9] tw-mt-3
                    before:tw-content-[''] before:tw-absolute before:tw-top-[-22px] before:tw-h-[22px] before:tw-inset-x-0"
            >
              <ul className="list-unstyled">
                {headerDropdown
                  ?.sort((x, y) => Number(y.checked) - Number(x.checked))
                  ?.map((item, index) => (
                    <li className="header-showroom-li">
                      <a
                        data-url={item.cta_link}
                        onClick={() => {
                          updateShowroom(item.id, item.cta_text);
                          trackEventWithObject({
                            event: 'header',
                            general_event_category: 'Visit Showrooms',
                            general_event_section: 'Radio Button',
                            general_event_details: item.cta_text,
                          });
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={event => {
                          if (event.key === 'Enter') {
                            updateShowroom(item.id, item.cta_text);
                            trackEventWithObject({
                              event: 'header',
                              general_event_category: 'Visit Showrooms',
                              general_event_section: 'Radio Button',
                              general_event_details: item.cta_text,
                            });
                          }
                        }}
                        className="radio-green-cricle hover:!tw-text-[#333] focus:tw-outline-none focus-visible:tw-outline-[-webkit-focus-ring-color]"
                      >
                        <i className={beTwMerge(item.checked ? 'icons-checked' : 'icons-checkbox')} />
                        <span className="tw-font-base tw-font-normal">{`${item.cta_text}`}</span>
                        {index === 0 && (
                          <div className="tw-text-xs">
                            <p className="tw-font-book tw-pt-[5px]">{item.hours}</p>
                            <p className="tw-font-book tw-m-0">{item.address}</p>
                            <p className="tw-font-book">{item.address_line_2}</p>
                          </div>
                        )}
                      </a>
                    </li>
                  ))}
              </ul>

              <Button
                className="!tw-w-full !tw-text-[15px] tw-my-2 !tw-text-white"
                label="VISIT US"
                color="dark-green"
                type="primary"
                href={headerDropdown?.[0]?.cta_link}
                onClick={() => {
                  trackEventWithObject({
                    event: 'header',
                    general_event_category: 'Visit Showrooms',
                    general_event_section: 'Visit Us',
                    general_event_details: showroomName || 'Undefined',
                  });
                }}
              />
              <div
                onClick={() => {
                  trackEventWithObject({
                    event: 'header',
                    general_event_category: 'Visit Showrooms',
                    general_event_section: 'View All Locations',
                    general_event_details: showroomName || 'Undefined',
                  });
                }}
                role="none"
              >
                <Button
                  className="!tw-w-full !tw-text-[15px] !tw-block"
                  label="View All Locations"
                  color="dark-green"
                  type="link"
                  href="/stores/"
                />
              </div>
            </div>
          )}
        </Container>
      ) : null}
    </>
  );
}
